// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.tep-pv-calc-wrap[data-v-128458d9] {\r\n    display: flex;\r\n    align-items: center;\r\n    width: -moz-max-content;\r\n    width: max-content;\r\n    padding-top: 10px;\n}\n.tep-pv-calc-wrap[data-v-128458d9] .dx-button {\r\n    height: 33px;\n}\n.tep-btn-text[data-v-128458d9] {\r\n    margin-left: 0.5em;\r\n    font-weight: 500;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
